import { createContext, useContext, useState, useEffect } from "react";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const ImpersonationContext = createContext();

export const useImpersonation = () => {
  const context = useContext(ImpersonationContext);
  if (!context) {
    throw new Error("useImpersonation must be used within ImpersonationProvider");
  }
  return context;
};

export const ImpersonationProvider = ({ children }) => {
  const [impersonationSession, setImpersonationSession] = useState(null);
  const [isReadOnly, setIsReadOnly] = useState(false);

  useEffect(() => {
    checkCurrentImpersonation();
  }, []);

  const checkCurrentImpersonation = async () => {
    try {
      const token = localStorage.getItem("token");
      const user = JSON.parse(localStorage.getItem("user") || "{}");
      
      if (user.role !== "super_admin") {
        return;
      }

      const response = await axios.get(`${API}/super-admin/current-impersonation`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      if (response.data.is_impersonating) {
        setImpersonationSession(response.data.session);
        setIsReadOnly(true);
      }
    } catch (error) {
      console.error("Failed to check impersonation status:", error);
    }
  };

  const startImpersonation = (session) => {
    setImpersonationSession(session);
    setIsReadOnly(true);
  };

  const endImpersonation = async () => {
    try {
      const token = localStorage.getItem("token");
      await axios.post(
        `${API}/super-admin/end-impersonation`,
        {},
        { headers: { Authorization: `Bearer ${token}` } }
      );

      setImpersonationSession(null);
      setIsReadOnly(false);
      
      return true;
    } catch (error) {
      console.error("Failed to end impersonation:", error);
      return false;
    }
  };

  const value = {
    impersonationSession,
    isReadOnly,
    isImpersonating: !!impersonationSession,
    startImpersonation,
    endImpersonation,
    refreshImpersonation: checkCurrentImpersonation
  };

  return (
    <ImpersonationContext.Provider value={value}>
      {children}
    </ImpersonationContext.Provider>
  );
};
